module.exports = __webpack_public_path__ + "img/75674.19975348.svg";